import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { useNavigate } from 'react-router-dom';
import '../../styles/Login.css';

function ForgotPassword() {
    const [email, setEmail] = useState('');
    const [message, setMessage] = useState('');
    const [isError, setIsError] = useState(false);
    const navigate = useNavigate();

    useEffect(() => {
        window.addEventListener("unhandledrejection", function (event) {
            console.log("🛑 UNHANDLED PROMISE ERROR:", event.reason);
        });
    }, []);

    const handleSubmit = async (e) => {
        e.preventDefault();
        console.log('📨 Sending reset link to:', email);

        try {
            const res = await axios.post(`${process.env.REACT_APP_API_BASE_URL}/api/forgot-password`, { email });
            setMessage(res.data.message || '✔️ Reset password email sent!');
            setIsError(false);
        } catch (err) {
            const msg = err.response?.data?.message || '❌ Failed to send reset email';
            setMessage(msg);
            setIsError(true);
        }
    };

    return (
        <div className="login-container">
            <div className="login-form-wrapper">
                <h3 className="mb-4">Forgot Password</h3>
                <form onSubmit={handleSubmit}>
                    <div className="mb-3">
                        <label>Email address</label>
                        <input
                            type="email"
                            className="form-control"
                            value={email}
                            onChange={(e) => setEmail(e.target.value)}
                            required
                        />
                    </div>

                    <div className="d-flex justify-content-between">
                        <button type="button" className="btn btn-secondary px-4" onClick={() => navigate('/')}>
                            Cancel
                        </button>
                        <button type="submit" className="btn btn-primary px-4">
                            Send Reset Link
                        </button>
                    </div>

                    {message && (
                        <div
                            className="mt-3"
                            style={{
                                padding: '10px',
                                backgroundColor: isError ? '#f8d7da' : '#d4edda',
                                color: isError ? '#721c24' : '#155724',
                                border: '1px solid',
                                borderColor: isError ? '#f5c6cb' : '#c3e6cb',
                                borderRadius: '5px',
                                textAlign: 'center',
                                fontSize: '0.95rem'
                            }}
                        >
                            {message}
                        </div>
                    )}
                </form>
            </div>
        </div>
    );
}

export default ForgotPassword;
